// frontend/src/components/ModuloUpsellModal/ModuloUpsellModal.jsx
import React from 'react';
import { Modal, Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Paragraph, Text } = Typography;

const COPY = {
  milhas: {
    title: 'Módulo Milhas necessário',
    description:
      'Para registrar pontos de cartão você precisa do módulo Milhas. Atualize para o plano Completo ou adicione Milhas em Meu Plano.',
  },
  financeiro: {
    title: 'Módulo Financeiro necessário',
    description:
      'Para criar conta a receber você precisa do módulo Financeiro. Atualize para o plano Completo ou adicione Financeiro em Meu Plano.',
  },
};

/**
 * @param {'milhas'|'financeiro'} moduloFaltante
 */
const ModuloUpsellModal = ({ open, onClose, moduloFaltante = 'milhas' }) => {
  const navigate = useNavigate();
  const copy = COPY[moduloFaltante] || COPY.milhas;

  const handleGoPlan = () => {
    onClose?.();
    navigate('/meu-plano');
  };

  return (
    <Modal
      open={open}
      title={copy.title}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose}>
          Agora não
        </Button>,
        <Button key="plan" type="primary" onClick={handleGoPlan}>
          Ver Meu Plano
        </Button>,
      ]}
    >
      <Paragraph>{copy.description}</Paragraph>
      <Text type="secondary">
        Com o plano Completo você une milhas e financeiro em um só lugar.
      </Text>
    </Modal>
  );
};

export default ModuloUpsellModal;
